import { useGetSafeClientCode } from '@/hooks/router'
import { Link } from '@tanstack/react-router'

import { InstrumentDto, MarketDetailDto } from '@/gen/publicApi'

import { Badge } from '@/components/badge'
import Content from '@/components/content'
import InstrumentStateCircle from '@/components/instrumentStateCircle'

import MarketHeading from '../../../-components/marketHeading'

interface Props {
    market: MarketDetailDto
    instrument: InstrumentDto
}

export default function InstrumentHeading({ market, instrument }: Props) {
    const clientCode = useGetSafeClientCode()

    return (
        <>
            <MarketHeading market={market} />
            <Content>
                <div className="flex-grow mb-4">
                    <div className="flex items-center">
                        <h3>
                            <Link
                                to="/$client_code/markets/$market_code/instruments/$instrument_symbol"
                                params={{
                                    client_code: clientCode,
                                    market_code: market.code,
                                    instrument_symbol: instrument.symbol,
                                }}
                            >
                                {instrument.name}
                            </Link>
                        </h3>
                        <Badge className="mx-4" variant="outline">
                            {instrument.symbol}
                        </Badge>
                        <InstrumentStateCircle state={instrument.state} className="ml-2" />
                    </div>
                </div>
            </Content>
        </>
    )
}
